/* Motoparts.py · Guía de talles paso a paso (tema v17, 12/10/2026).
   Una pregunta por pantalla. Usa las tablas y el motor de assets/mp-talles.js (window.MPGuiaTalles._t).
   Las medidas se guardan solo en el navegador del cliente (misma clave que la ficha de producto).
   El resultado enlaza a /pages/tablas-de-talles?tipo=...&talle=... (tabla completa con el talle marcado). */
(function () {
  'use strict';

  var WA = 'https://wa.me/595982150388?text=';
  var LS_KEY = 'mp-medidas-v1';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(n) { var r = Math.round(n * 10) / 10; return String(r).replace('.', ','); }
  function num(v) { if (v == null) return NaN; var s = String(v).trim().replace(',', '.'); return s ? parseFloat(s) : NaN; }
  function leer() { try { return JSON.parse(window.localStorage.getItem(LS_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function guardar(o) { try { window.localStorage.setItem(LS_KEY, JSON.stringify(o)); } catch (e) {} }

  function bordes(rr) { var B = [rr[0][0]]; for (var j = 1; j < rr.length; j++) B.push((rr[j - 1][1] + rr[j][0]) / 2); B.push(rr[rr.length - 1][1]); return B; }
  function posDe(rr, x) {
    var B = bordes(rr), n = B.length - 1;
    if (x <= B[0]) return (x - B[0]) / ((B[1] - B[0]) || 1);
    for (var i = 0; i < n; i++) if (x <= B[i + 1]) return i + (x - B[i]) / ((B[i + 1] - B[i]) || 1);
    return n + (x - B[n]) / ((B[n] - B[n - 1]) || 1);
  }

  /* ---------- Dibujos ---------- */
  var FIG = {
    cuerpo: function (mk) {
      var marcas = {
        estatura: '<path d="M226 16v388M218 16h16M218 404h16"/>',
        pecho: '<path d="M74 116a44 11 0 0 1 88 0" stroke-width="3" stroke-dasharray="6 6"/><path d="M74 116a44 11 0 0 0 88 0" stroke-width="5"/><path d="M148 124l13-2-5 11" stroke-width="3.5" stroke-linejoin="round"/>'
      };
      return '<svg viewBox="0 0 250 420" class="mpp-fig" aria-hidden="true"><g fill="#eef0f3" stroke="#b9bfc8" stroke-width="1.5" stroke-linejoin="round">' +
        '<circle cx="118" cy="40" r="23"/><path d="M108 62h20v14h-20z"/>' +
        '<path d="M74 84c10-8 26-10 44-10s34 2 44 10l8 46-8 60 4 46c-6 10-12 18-14 22l-6 140h-20l-6-124-6 124h-20l-6-140c-2-4-8-12-14-22l4-46-8-60z"/>' +
        '<path d="M74 86c-12 6-16 18-18 34l-10 92 12 4 14-82"/><path d="M162 86c12 6 16 18 18 34l10 92-12 4-14-82"/></g>' +
        '<g stroke="#d32f2f" stroke-width="4" fill="none" stroke-linecap="round">' + (marcas[mk] || '') + '</g></svg>';
    },
    peso: function () {
      return '<svg viewBox="0 0 200 200" class="mpp-fig" aria-hidden="true"><rect x="30" y="40" width="140" height="130" rx="26" fill="#eef0f3" stroke="#b9bfc8" stroke-width="3"/>' +
        '<path d="M64 92a36 36 0 0 1 72 0z" fill="#fff" stroke="#b9bfc8" stroke-width="3"/><path d="M100 92l16-22" stroke="#d32f2f" stroke-width="5" stroke-linecap="round"/>' +
        '<rect x="62" y="128" width="76" height="12" rx="6" fill="#b9bfc8"/></svg>';
    },
    cabeza: function () {
      return '<svg viewBox="0 0 220 230" class="mpp-fig" aria-hidden="true"><g fill="#eef0f3" stroke="#b9bfc8" stroke-width="2" stroke-linejoin="round">' +
        '<ellipse cx="36" cy="112" rx="9" ry="17"/><ellipse cx="184" cy="112" rx="9" ry="17"/>' +
        '<path d="M110 20c-46 0-74 34-74 82 0 30 10 52 26 66v42h96v-42c16-14 26-36 26-66 0-48-28-82-74-82z"/></g>' +
        '<g stroke="#9aa1ab" stroke-width="3" stroke-linecap="round" fill="none"><path d="M78 104q11-6 22 0M120 104q11-6 22 0"/><path d="M86 122h8M126 122h8"/><path d="M100 160q10 6 20 0"/></g>' +
        '<path d="M34 80a76 14 0 0 1 152 0" fill="none" stroke="#d32f2f" stroke-width="3" stroke-dasharray="6 6"/>' +
        '<path d="M34 80a76 14 0 0 0 152 0" fill="none" stroke="#d32f2f" stroke-width="4"/>' +
        '<g stroke="#0f1115" stroke-width="1.6"><path d="M160 86v14M155 86h10M155 100h10"/></g>' +
        '<text x="168" y="98" fill="#0f1115" font-family="Montserrat, Inter, sans-serif" font-size="12" font-weight="700">2 dedos</text></svg>';
    },
    mano: function () {
      return '<svg viewBox="0 0 200 250" class="mpp-fig" aria-hidden="true"><g fill="#eef0f3" stroke="#b9bfc8" stroke-width="2" stroke-linejoin="round">' +
        '<rect x="62" y="196" width="76" height="46" rx="10"/><rect x="52" y="34" width="22" height="86" rx="11"/><rect x="77" y="20" width="22" height="98" rx="11"/>' +
        '<rect x="102" y="24" width="22" height="94" rx="11"/><rect x="127" y="44" width="21" height="76" rx="10.5"/>' +
        '<rect x="14" y="118" width="22" height="66" rx="11" transform="rotate(-32 25 151)"/><rect x="48" y="96" width="102" height="110" rx="26"/></g>' +
        '<path d="M44 122a56 9 0 0 0 108 0" fill="none" stroke="#d32f2f" stroke-width="4"/>' +
        '<path d="M44 122a56 9 0 0 1 108 0" fill="none" stroke="#d32f2f" stroke-width="3" stroke-dasharray="6 6"/></svg>';
    },
    pie: function () {
      return '<svg viewBox="0 0 170 270" class="mpp-fig" aria-hidden="true"><path d="M78 18c-30 0-46 28-46 64 0 30 8 50 10 74 2 26-8 44-8 64 0 24 18 38 44 38s44-14 44-38c0-20-10-38-8-64 2-24 10-44 10-74 0-36-16-64-46-64z" fill="#eef0f3" stroke="#b9bfc8" stroke-width="2"/>' +
        '<g stroke="#d32f2f" stroke-width="3.5" stroke-linecap="round"><path d="M148 18v240M140 18h16M140 258h16"/></g></svg>';
    }
  };

  var ICO = {
    casco: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 30c0-11 7-20 17-20 9 0 15 7 15 16v6H22c-2 0-3 1-3 3v3H11c-2 0-3-1-3-3z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><path d="M22 22h18" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>',
    mono: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M17 6h14l8 8-4 6-3-3v25h-7l-1-14-1 14h-7V17l-3 3-4-6z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/></svg>',
    indoor: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M10 26a14 12 0 0 1 28 0z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><path d="M24 26v12a4 4 0 0 1-8 0" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><path d="M24 10v4" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>',
    guantes: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M14 40V20c0-2 1-3 3-3s3 1 3 3v-9c0-2 1-3 3-3s3 1 3 3v8-10c0-2 1-3 3-3s3 1 3 3v12-6c0-2 1-3 2-3 2 0 3 1 3 3v12c0 8-5 13-12 13h-6z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/></svg>',
    calzado: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M6 32V16h10c2 4 6 6 10 6l12 3c3 1 4 3 4 6v3H8c-1 0-2-1-2-2z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><path d="M6 38h36" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>',
    costillas: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 8v32" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><path d="M24 14c-6 0-12 2-14 6M24 14c6 0 12 2 14 6M24 22c-6 0-11 2-13 6M24 22c6 0 11 2 13 6M24 30c-5 0-9 2-11 5M24 30c5 0 9 2 11 5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>'
  };

  /* ---------- Productos ---------- */
  var PROD = {
    casco: { t: 'Casco', d: 'MT Helmets y Lola', ico: 'casco', quien: false },
    mono: { t: 'Mameluco de karting', d: 'Trajes FIA y cadete', ico: 'mono', quien: ['hombre', 'mujer', 'nino'] },
    indoor: { t: 'Indoor, lluvia o ropa técnica', d: 'Talles por letra', ico: 'indoor', quien: ['hombre', 'mujer'] },
    guantes: { t: 'Guantes', d: 'Adultos y chicos', ico: 'guantes', quien: ['hombre', 'mujer', 'nino'] },
    calzado: { t: 'Calzado de karting', d: 'Zapatillas y botas', ico: 'calzado', quien: ['hombre', 'mujer', 'nino'] },
    costillas: { t: 'Protector de costillas', d: 'Bionic Rib Support', ico: 'costillas', quien: ['hombre', 'mujer'] }
  };
  var ORDEN = ['casco', 'mono', 'guantes', 'calzado', 'indoor', 'costillas'];
  var QUIEN = { hombre: 'Hombre', mujer: 'Mujer', nino: 'Chico o chica (hasta 12 años)' };

  function tipoMotor(s) {
    var n = s.quien === 'nino';
    switch (s.prod) {
      case 'casco': return 'casco-mt';
      case 'mono': return n ? 'mono-ninos' : 'mono-adulto';
      case 'indoor': return 'ropa-letras';
      case 'guantes': return n ? 'guantes-ninos' : 'guantes-adulto';
      case 'calzado': return n ? 'calzado-ninos' : 'calzado-adulto';
      case 'costillas': return 'costillas-adulto';
    }
    return 'mono-adulto';
  }

  /* ---------- Pasos ---------- */
  // Cada paso: k (medida), q (pregunta), how (cómo medir), u, min, max, st, def, fig, opc (se puede saltar)
  function pasoDe(k, s) {
    var n = s.quien === 'nino', m = s.quien === 'mujer', su = n ? 'Su ' : 'Tu ';
    switch (k) {
      case 'height': return { k: k, q: n ? '¿Cuánto mide?' : '¿Cuánto medís?', how: 'Descalzo, de espaldas a la pared, del piso a la coronilla.', u: 'cm', min: n ? 90 : 120, max: n ? 175 : 215, st: 1, def: n ? 130 : (m ? 165 : 175), fig: FIG.cuerpo('estatura') };
      case 'weight': return { k: k, q: '¿Cuánto pesás?', how: 'Con tu estatura y tu peso estimamos pecho y cintura. No hace falta medir nada más.', u: 'kg', min: 30, max: 180, st: 1, def: m ? 62 : 78, fig: FIG.peso() };
      case 'chest': return { k: k, q: n ? '¿Querés sumar el contorno de su pecho?' : '¿Querés sumar el contorno de tu pecho?', how: (n ? 'Pasá la cinta alrededor de su pecho, por la parte más ancha y debajo de las axilas, derecha y sin apretar: tiene que dar toda la vuelta. Es opcional: afina el talle.' : 'Pasá la cinta alrededor del pecho, por la parte más ancha y debajo de las axilas, derecha y sin apretar: tiene que dar toda la vuelta. Es opcional: afina el talle.'), u: 'cm', min: 50, max: 160, st: 0.5, def: n ? 70 : (m ? 92 : 100), fig: FIG.cuerpo('pecho'), opc: 1 };
      case 'head': return { k: k, q: 'Medí tu cabeza', how: 'Pasá la cinta dos dedos arriba de las cejas y por la parte más ancha de la nuca, sin apretar.', u: 'cm', min: 48, max: 68, st: 0.5, def: 57, fig: FIG.cabeza(), alt: 'No tengo cinta métrica' };
      case 'hand': return { k: k, q: n ? 'Medí su mano' : 'Medí tu mano', how: 'Alrededor de la palma, en la parte más ancha y sin el pulgar. ' + (n ? 'La mano con la que escribe.' : 'La mano con la que escribís.'), u: 'cm', min: 12, max: 30, st: 0.5, def: n ? 16.5 : (m ? 19 : 21.5), fig: FIG.mano(), alt: 'No tengo cinta métrica' };
      case 'foot': return { k: k, q: n ? '¿Querés medir su pie?' : '¿Querés medir tu pie?', how: 'Parado sobre una hoja contra la pared: marcá la punta del dedo más largo y medí desde el talón. Es opcional, pero es lo más preciso.', u: 'cm', min: 15, max: 34, st: 0.5, def: 26, fig: FIG.pie(), opc: 1 };
    }
    return null;
  }

  function flujo(s) {
    if (!s.prod) return ['prod'];
    var f = ['prod'];
    var P = PROD[s.prod];
    if (P.quien) f.push('quien');
    if (s.prod !== 'casco' && P.quien && !s.quien) return f;
    switch (s.prod) {
      case 'casco': f = f.concat(s.sinCinta ? ['casco_talle', 'casco_calce'] : ['head']); break;
      case 'mono': f = f.concat(s.quien === 'nino' ? ['height', 'chest'] : ['height', 'weight', 'chest']); break;
      case 'indoor': f = f.concat(['height', 'weight', 'chest']); break;
      case 'costillas': f = f.concat(['height', 'weight', 'chest']); break;
      case 'guantes': f = f.concat(s.sinCinta ? ['height'] : ['hand']); break;
      case 'calzado': f = f.concat(['eu', 'foot']); break;
    }
    f.push('res');
    return f;
  }

  /* ---------- Cálculo ---------- */
  function calcular(s) {
    var M = window.MPGuiaTalles && window.MPGuiaTalles._t;
    if (!M) return null;
    var tipo = tipoMotor(s), T = M.TIPOS[tipo], v = s.v, n = s.quien === 'nino', sexo = s.quien === 'mujer' ? 'mujer' : 'hombre';
    if (s.prod === 'casco') { var vc = {}; for (var kc in v) vc[kc] = v[kc]; if (s.sinCinta) delete vc.head; else { delete vc.casco_talle; delete vc.casco_calce; } return calcCasco(T, vc); }
    if (s.prod === 'calzado') return calcCalzado(T, v, n);
    if (s.prod === 'guantes') {
      var hand = s.sinCinta ? null : v.hand, h = v.height, est = null, nota = '';
      if (hand == null && h != null) {
        if (n) {
          var Y = M.TIPOS['mono-ninos'].chart, i = Math.max(0, Math.min(3, Math.floor(posDe(Y.m.height, h))));
          var rr = T.chart.m.hand[i + 1]; est = (rr[0] + rr[1]) / 2;
        } else est = sexo === 'mujer' ? 18.9 + 0.07 * (h - 166) : 21.6 + 0.075 * (h - 176);
        nota = 'Lo estimamos por la estatura. Si podés, medí la palma para confirmarlo.';
      }
      var x = hand != null ? hand : est;
      var r = M.calcular(T.chart, [{ k: 'hand', v: x, w: 1, est: hand == null }]);
      return { T: T, talle: T.chart.sizes[r.i], alt: r.otro != null ? T.chart.sizes[r.otro] : null, fuera: r.meds[0].fuera, nota: nota,
        base: hand != null ? 'Palma ' + fmt(hand) + ' cm' : 'Estatura ' + fmt(h) + ' cm' };
    }
    // cuerpo
    var meds = [], vals = {};
    ['height', 'weight', 'chest'].forEach(function (k) { if (v[k] != null) vals[k] = v[k]; });
    if (vals.height != null && T.chart.m.height) meds.push({ k: 'height', v: vals.height, w: 1 });
    if (vals.chest != null && T.chart.m.chest) meds.push({ k: 'chest', v: sexo === 'mujer' && !n ? vals.chest - 4 : vals.chest, w: 1 });
    if (!n) {
      var e = M.estimar(vals, sexo);
      ['chest', 'waist', 'hip'].forEach(function (k) {
        if (vals[k] == null && e[k] != null && T.chart.m[k] && (e.peso || sexo === 'mujer')) meds.push({ k: k, v: e[k], w: e.peso ? 0.6 : 0.35, est: 1 });
      });
    }
    if (!meds.length) return null;
    var res = M.calcular(T.chart, meds), sizes = T.chart.sizes, fuera = 0;
    res.meds.forEach(function (m) { if (m.fuera && !m.est && m.ids.indexOf(res.i) >= 0) fuera = m.fuera; });
    var partes = [];
    if (vals.height != null) partes.push(fmt(vals.height) + ' cm');
    if (vals.weight != null) partes.push(fmt(vals.weight) + ' kg');
    if (vals.chest != null) partes.push('pecho ' + fmt(vals.chest) + ' cm');
    return { T: T, talle: sizes[res.i], alt: res.otro != null ? sizes[res.otro] : null, i: res.i, fuera: fuera, base: 'Con ' + partes.join(', ').replace(/, ([^,]*)$/, ' y $1') };
  }

  function calcCasco(T, v) {
    var sz = T.chart.sizes, rr = T.chart.m.head, n = sz.length, x = v.head, i;
    if (x != null) {
      if (x < rr[0][0] - 0.5) return { T: T, talle: sz[0], fuera: -1, base: 'Cabeza ' + fmt(x) + ' cm' };
      if (x > rr[n - 1][1] + 0.5) return { T: T, talle: sz[n - 1], fuera: 1, base: 'Cabeza ' + fmt(x) + ' cm' };
      for (i = 0; i < n; i++) {
        if (x >= rr[i][0] - 0.001 && x <= rr[i][1] + 0.001) return { T: T, talle: sz[i], base: 'Cabeza ' + fmt(x) + ' cm' };
        if (i < n - 1 && x > rr[i][1] && x < rr[i + 1][0]) return { T: T, talle: sz[i], alt: sz[i + 1], base: 'Cabeza ' + fmt(x) + ' cm' };
      }
      return { T: T, talle: x < rr[0][0] ? sz[0] : sz[n - 1], base: 'Cabeza ' + fmt(x) + ' cm' };
    }
    if (v.casco_talle) {
      var j = sz.indexOf(v.casco_talle);
      if (v.casco_calce === 'flojo') j -= 1; else if (v.casco_calce === 'aprieta') j += 1;
      var fuera = j < 0 ? -1 : (j > n - 1 ? 1 : 0);
      j = Math.max(0, Math.min(n - 1, j));
      return { T: T, talle: sz[j], fuera: fuera, porCasco: 1, base: 'Tu casco actual ' + v.casco_talle + (v.casco_calce === 'flojo' ? ', que te queda flojo' : v.casco_calce === 'aprieta' ? ', que te aprieta' : ', que te queda bien'),
        nota: 'Cada marca calza distinto: si podés, medí tu cabeza para confirmarlo.' };
    }
    return null;
  }

  function calcCalzado(T, v, ninos) {
    var lista = T.list, L = v.foot, E = v.eu, base = null, nota = '';
    if (L != null) base = L;
    else if (E != null) {
      var ex = null; lista.forEach(function (x) { if (ex == null && x.eu >= E - 0.01) ex = x; });
      if (!ex) ex = lista[lista.length - 1];
      base = ex.cm - 0.01; nota = 'Cada marca calza distinto: si podés, medí el pie para confirmarlo.';
    }
    if (base == null) return null;
    var el = null, sig = null, i;
    for (i = 0; i < lista.length; i++) { if (lista[i].cm >= base - 0.05) { el = lista[i]; sig = lista[i + 1] || null; break; } }
    var fuera = 0;
    if (!el) { el = lista[lista.length - 1]; fuera = 1; } else if (lista[0] === el && base < el.cm - 1.2) fuera = -1;
    var justo = L != null && el.cm - L < 0.3 && sig;
    void ninos;
    return { T: T, shoe: 1, talle: 'US ' + fmt(num(el.s)), eu: el.eu, cm: el.cm, alt: justo ? 'US ' + fmt(num(sig.s)) : null, fuera: fuera, nota: nota,
      base: L != null ? 'Pie de ' + fmt(L) + ' cm' : 'Número habitual EU ' + fmt(E) };
  }

  /* ---------- Widget ---------- */
  function Paso(root) {
    this.root = root;
    var g = leer();
    this.s = { prod: null, quien: null, sinCinta: false, v: {}, i: 0 };
    this.guardado = g;
    var ini = root.getAttribute('data-inicio') || '';
    try { var q = new URLSearchParams(location.search).get('tipo'); if (q) ini = q; } catch (e) {}
    var MAP = { 'casco-mt': ['casco'], 'casco-lola': ['casco'], casco: ['casco'], 'mono-adulto': ['mono'], 'mono-ninos': ['mono', 'nino'], 'ropa-letras': ['indoor'], 'top-letras': ['indoor'],
      'guantes-adulto': ['guantes'], 'guantes-ninos': ['guantes', 'nino'], 'calzado-adulto': ['calzado'], 'calzado-ninos': ['calzado', 'nino'], 'costillas-adulto': ['costillas'] };
    if (MAP[ini]) { this.s.prod = MAP[ini][0]; if (MAP[ini][1]) this.s.quien = MAP[ini][1]; this.s.i = (this.s.quien && PROD[this.s.prod].quien) ? 2 : 1; }
    this.bind();
    this.render(false);
  }

  Paso.prototype.pasos = function () { return flujo(this.s); };

  Paso.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-a]'); if (!b || !self.root.contains(b)) return;
      var a = b.getAttribute('data-a'), val = b.getAttribute('data-v');
      if (a === 'prod') { if (self.s.prod !== val) { self.s.quien = null; self.s.sinCinta = false; } self.s.prod = val; self.ir(1); }
      else if (a === 'quien') { self.s.quien = val; self.ir(1); }
      else if (a === 'sig') { if (self.leerNumero()) self.ir(1); }
      else if (a === 'saltar') { var k = b.getAttribute('data-k'); delete self.s.v[k]; self.ir(1); }
      else if (a === 'atras') self.ir(-1);
      else if (a === 'menos' || a === 'mas') self.mover(a === 'mas' ? 1 : -1);
      else if (a === 'sincinta') { self.s.sinCinta = true; self.render(true); }
      else if (a === 'concinta') { self.s.sinCinta = false; self.render(true); }
      else if (a === 'chip') { var kk = b.getAttribute('data-k'); self.s.v[kk] = /^[\d.]+$/.test(val) ? parseFloat(val) : val; self.ir(1); }
      else if (a === 'reiniciar') { self.s = { prod: null, quien: null, sinCinta: false, v: {}, i: 0 }; self.render(true); }
      else if (a === 'medida') { var paso = self.pasos().indexOf(val); if (paso >= 0) { self.s.i = paso; self.render(true); } }
    });
    this.root.addEventListener('input', function (e) {
      if (e.target.matches('.mpp-range')) { var inp = $('.mpp-num input', self.root); if (inp) inp.value = fmt(parseFloat(e.target.value)); self.validar(); }
      if (e.target.matches('.mpp-num input')) { var r = $('.mpp-range', self.root), x = num(e.target.value); if (r && !isNaN(x)) r.value = x; self.validar(); }
    });
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('.mpp-num input')) { e.preventDefault(); if (self.leerNumero()) self.ir(1); }
    });
  };

  Paso.prototype.ir = function (d) {
    var f = this.pasos();
    this.s.i = Math.max(0, Math.min(f.length - 1, this.s.i + d));
    // si el flujo cambió (por ejemplo, se eligió producto), recalcular
    f = this.pasos();
    if (this.s.i > f.length - 1) this.s.i = f.length - 1;
    if (f[this.s.i] === 'res') this.guardar();
    this.render(true);
  };

  Paso.prototype.guardar = function () {
    var g = leer(), pref = this.s.quien === 'nino' ? 'n_' : '', v = this.s.v;
    ['height', 'weight', 'chest', 'hand', 'foot', 'eu', 'head'].forEach(function (k) { if (v[k] != null) g[(k === 'head' ? '' : pref) + k] = v[k]; });
    if (v.casco_talle) g.casco_talle = v.casco_talle;
    if (v.casco_calce) g.casco_calce = v.casco_calce;
    if (this.s.quien === 'hombre' || this.s.quien === 'mujer') g.sexo = this.s.quien;
    guardar(g);
  };

  Paso.prototype.defecto = function (p) {
    var pref = this.s.quien === 'nino' ? 'n_' : '';
    var x = this.s.v[p.k];
    if (x == null) { var g = this.guardado[(p.k === 'head' ? '' : pref) + p.k]; if (g != null && !isNaN(g) && g >= p.min && g <= p.max) x = g; }
    if (x == null && p.k === 'foot' && this.s.v.eu != null) {
      var T = window.MPGuiaTalles._t.TIPOS[tipoMotor(this.s)], ex = null;
      T.list.forEach(function (r) { if (ex == null && r.eu >= this.s.v.eu - 0.01) ex = r; }, this);
      if (ex) x = ex.cm;
    }
    return x != null ? x : p.def;
  };

  Paso.prototype.mover = function (d) {
    var inp = $('.mpp-num input', this.root), r = $('.mpp-range', this.root); if (!inp) return;
    var st = parseFloat(r.step) || 1, x = num(inp.value); if (isNaN(x)) x = parseFloat(r.value);
    x = Math.round((x + d * st) / st) * st;
    x = Math.max(parseFloat(r.min), Math.min(parseFloat(r.max), x));
    inp.value = fmt(x); r.value = x; this.validar();
  };

  Paso.prototype.validar = function () {
    var inp = $('.mpp-num input', this.root), r = $('.mpp-range', this.root), err = $('.mpp-err', this.root); if (!inp) return true;
    var x = num(inp.value), k = inp.name;
    if (k === 'height' && x > 0 && x < 3) x = x * 100;
    var ok = !isNaN(x) && x >= parseFloat(r.min) && x <= parseFloat(r.max);
    err.hidden = ok; inp.closest('.mpp-num').classList.toggle('is-error', !ok);
    return ok ? x : null;
  };

  Paso.prototype.leerNumero = function () {
    var inp = $('.mpp-num input', this.root); if (!inp) return true;
    var x = this.validar(); if (x == null) { inp.focus(); return false; }
    this.s.v[inp.name] = x; return true;
  };

  Paso.prototype.render = function (foco) {
    var f = this.pasos(), id = f[this.s.i] || 'prod', s = this.s, h = '';
    var est = { prod: s.prod || 'mono', quien: s.quien || 'hombre', sinCinta: s.sinCinta, v: s.v };
    if (est.prod && !PROD[est.prod].quien) est.quien = null;
    var fe = flujo(est), total = fe.length - 1;
    var actual = Math.min(this.s.i + 1, total);
    if (id !== 'res') {
      h += '<div class="mpp-top">' + (this.s.i > 0 ? '<button type="button" class="mpp-atras" data-a="atras" aria-label="Volver al paso anterior">← Atrás</button>' : '<span></span>') +
        '<span class="mpp-cont">Paso ' + actual + ' de ' + total + '</span></div>' +
        '<div class="mpp-barra" aria-hidden="true"><i style="width:' + Math.round(actual / total * 100) + '%"></i></div>';
    }
    h += '<div class="mpp-paso" data-paso="' + id + '">';
    if (id === 'prod') {
      h += '<h2 class="mpp-q">¿Qué querés elegir?</h2><div class="mpp-cards">';
      ORDEN.forEach(function (k) {
        var P = PROD[k];
        h += '<button type="button" class="mpp-card' + (s.prod === k ? ' is-on' : '') + '" data-a="prod" data-v="' + k + '"><span class="mpp-ico">' + ICO[P.ico] + '</span><span><b>' + esc(P.t) + '</b><small>' + esc(P.d) + '</small></span></button>';
      });
      h += '</div>';
    } else if (id === 'quien') {
      h += '<h2 class="mpp-q">¿Para quién es?</h2><div class="mpp-opts">';
      PROD[s.prod].quien.forEach(function (k) { h += '<button type="button" class="mpp-opt' + (s.quien === k ? ' is-on' : '') + '" data-a="quien" data-v="' + k + '">' + esc(QUIEN[k]) + '</button>'; });
      h += '</div>';
      if (s.prod === 'mono') h += '<p class="mpp-how">Los mamelucos de chicos van del talle 120 al 150 (de 6 a 12 años, más o menos).</p>';
    } else if (id === 'casco_talle') {
      h += '<h2 class="mpp-q">¿Qué talle de casco usás hoy?</h2><p class="mpp-how">Está en la etiqueta, debajo del acolchado de la nuca.</p><div class="mpp-chips">';
      ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL'].forEach(function (t) { h += '<button type="button" class="mpp-chip' + (s.v.casco_talle === t ? ' is-on' : '') + '" data-a="chip" data-k="casco_talle" data-v="' + t + '">' + t + '</button>'; });
      h += '</div><button type="button" class="mpp-link" data-a="concinta">Mejor mido la cabeza</button>';
    } else if (id === 'casco_calce') {
      h += '<h2 class="mpp-q">¿Cómo te queda?</h2><div class="mpp-opts">';
      [['justo', 'Firme y cómodo'], ['flojo', 'Flojo, se mueve'], ['aprieta', 'Me aprieta o me duele']].forEach(function (o) {
        h += '<button type="button" class="mpp-opt' + (s.v.casco_calce === o[0] ? ' is-on' : '') + '" data-a="chip" data-k="casco_calce" data-v="' + o[0] + '">' + o[1] + '</button>';
      });
      h += '</div>';
    } else if (id === 'eu') {
      var nin = s.quien === 'nino', lista = nin ? [29, 30, 31, 32, 33] : [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47];
      h += '<h2 class="mpp-q">' + (nin ? '¿Qué número usa en zapatillas?' : '¿Qué número usás en zapatillas?') + '</h2><p class="mpp-how">El número europeo de siempre (por ejemplo, 42).</p><div class="mpp-chips">';
      lista.forEach(function (n) { h += '<button type="button" class="mpp-chip' + (s.v.eu === n ? ' is-on' : '') + '" data-a="chip" data-k="eu" data-v="' + n + '">' + n + '</button>'; });
      h += '</div>';
      if (nin) h += '<p class="mpp-how">Si calza 34 o más, volvé atrás y elegí Hombre o Mujer: ya usa calzado de adulto.</p>';
    } else if (id === 'res') {
      h += this.resultado();
    } else {
      var p = pasoDe(id, s), x = this.defecto(p);
      if (p.k === 'height' && s.prod === 'guantes') { p.how = 'No tenés cinta: con la estatura te damos un talle aproximado.'; }
      h += '<h2 class="mpp-q">' + esc(p.q) + '</h2>';
      h += '<div class="mpp-medir"><div class="mpp-dib">' + p.fig + '</div><p class="mpp-how">' + esc(p.how) + '</p></div>';
      h += '<div class="mpp-num"><button type="button" class="mpp-pm" data-a="menos" aria-label="Menos">−</button>' +
        '<label><input name="' + p.k + '" type="text" inputmode="decimal" autocomplete="off" value="' + esc(fmt(x)) + '" aria-label="' + esc(p.q) + ' en ' + p.u + '"><span>' + p.u + '</span></label>' +
        '<button type="button" class="mpp-pm" data-a="mas" aria-label="Más">+</button></div>';
      h += '<input class="mpp-range" type="range" min="' + p.min + '" max="' + p.max + '" step="' + p.st + '" value="' + x + '" aria-hidden="true" tabindex="-1">';
      h += '<p class="mpp-err" hidden>Revisá el número: tiene que estar entre ' + fmt(p.min) + ' y ' + fmt(p.max) + ' ' + p.u + '.</p>';
      h += '<div class="mpp-acc"><button type="button" class="mpp-btn" data-a="sig">' + (f[this.s.i + 1] === 'res' ? 'Ver mi talle' : 'Siguiente') + '</button>';
      if (p.opc) h += '<button type="button" class="mpp-link" data-a="saltar" data-k="' + p.k + '">' + (f[this.s.i + 1] === 'res' ? 'Saltar y ver mi talle' : 'Saltar') + '</button>';
      if (p.alt && !s.sinCinta) h += '<button type="button" class="mpp-link" data-a="sincinta">' + esc(p.alt) + '</button>';
      h += '</div>';
    }
    h += '</div>';
    this.root.innerHTML = h;
    if (foco) {
      var t = $('.mpp-q', this.root) || this.root;
      t.setAttribute('tabindex', '-1');
      try { t.focus({ preventScroll: true }); } catch (e) {}
      var top = this.root.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.6) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  Paso.prototype.resultado = function () {
    var s = this.s, r = calcular(s), h = '';
    if (!r) return '<p class="mpp-how">No pudimos calcular el talle. Escribinos y te ayudamos.</p>';
    var T = r.T, M = window.MPGuiaTalles._t;
    var eq = '';
    var LET = M.TIPOS['ropa-letras'].chart, YOUTH = M.TIPOS['mono-ninos'].chart;
    if (T.chart === LET) eq = '≈ talle europeo ' + LET.eu[LET.sizes.indexOf(r.talle)];
    if (T.chart === YOUTH) eq = YOUTH.int[YOUTH.sizes.indexOf(r.talle)] + ' internacional, ' + YOUTH.edad[YOUTH.sizes.indexOf(r.talle)] + ' años aprox.';
    if (r.shoe) eq = 'EU ' + fmt(r.eu) + ' · pie hasta ' + fmt(r.cm) + ' cm';
    h += '<div class="mpp-res">';
    h += '<p class="mpp-lbl">' + (s.quien === 'nino' ? 'Su talle' : 'Tu talle') + '</p><p class="mpp-talle">' + esc(r.talle) + '</p>';
    if (eq) h += '<p class="mpp-eq">' + esc(eq) + '</p>';
    h += '<p class="mpp-base">' + esc(r.base) + '.</p>';
    var nota = '';
    if (r.alt) {
      if (s.prod === 'casco') nota = 'Estás entre ' + r.talle + ' y ' + r.alt + '. Llevá el ' + r.talle + ': un casco nuevo tiene que quedar firme y el interior cede con el uso. Si te aprieta tanto que duele, lo cambiamos por el ' + r.alt + '.';
      else if (r.shoe) nota = 'Tu pie queda justo: si usás medias gruesas o tenés el pie ancho, el ' + r.alt + '.';
      else if (T.entre) {
        var sz = T.chart.sizes, a = sz.indexOf(r.talle) < sz.indexOf(r.alt) ? r.talle : r.alt, b = a === r.talle ? r.alt : r.talle;
        nota = 'Estás entre ' + a + ' y ' + b + '. ' + T.entre.replace(/\{a\}/g, a).replace(/\{b\}/g, b);
      }
    }
    if (r.nota) nota = (nota ? nota + ' ' : '') + r.nota;
    if (s.prod === 'casco' && r.talle === '3XL') nota = (nota ? nota + ' ' : '') + 'Lola llega hasta XXL: en 3XL tenés los MT Helmets.';
    if (nota) h += '<p class="mpp-nota">' + esc(nota) + '</p>';
    if (r.fuera) h += '<p class="mpp-alerta">' + (r.fuera < 0 ? 'Tu medida queda por debajo del talle más chico de la tabla.' : 'Tu medida supera el talle más grande de la tabla.') +
      (r.fuera > 0 && s.prod === 'mono' && s.quien === 'nino' ? ' Desde 160 cm conviene mirar los mamelucos de adulto.' : '') + ' Escribinos y lo vemos juntos.</p>';
    h += '<div class="mpp-acc">';
    if (T.col) h += '<a class="mpp-btn" href="' + T.col + '">' + esc(T.colT) + '</a>';
    h += '<a class="mpp-btn mpp-btn--wa" href="' + WA + encodeURIComponent(this.mensaje(r)) + '" target="_blank" rel="noopener">Confirmar por WhatsApp</a>';
    h += '</div>';
    // cambiar una medida
    var f = this.pasos().filter(function (k) { return k !== 'prod' && k !== 'res' && k !== 'quien'; });
    if (f.length) {
      h += '<p class="mpp-cambiar">Cambiar: ';
      var nombres = { height: 'estatura', weight: 'peso', chest: 'pecho', head: 'medida de cabeza', hand: s.sinCinta ? 'estatura' : 'medida de mano', eu: 'número', foot: 'largo del pie', casco_talle: 'talle actual', casco_calce: 'calce' };
      h += f.map(function (k) { return '<button type="button" class="mpp-link" data-a="medida" data-v="' + k + '">' + esc(nombres[k] || k) + '</button>'; }).join(' · ');
      h += '</p>';
    }
    h += '<p class="mpp-tabla"><a href="/pages/tablas-de-talles?tipo=' + tipoMotor(s) + '&amp;talle=' + encodeURIComponent(r.talle) + '">Ver la tabla completa con tu talle marcado</a></p>';
    h += '<button type="button" class="mpp-link mpp-otro" data-a="reiniciar">Calcular otro talle</button>';
    h += '<p class="mpp-cambio">Si no te queda, te lo cambiamos por otro talle. Tus medidas quedan guardadas solo en este celular.</p>';
    h += '</div>';
    return h;
  };

  Paso.prototype.mensaje = function (r) {
    var s = this.s, v = s.v, partes = [];
    if (v.height != null) partes.push('estatura ' + fmt(v.height) + ' cm');
    if (v.weight != null) partes.push('peso ' + fmt(v.weight) + ' kg');
    if (v.chest != null) partes.push('pecho ' + fmt(v.chest) + ' cm');
    if (v.head != null) partes.push('cabeza ' + fmt(v.head) + ' cm');
    if (v.hand != null) partes.push('palma ' + fmt(v.hand) + ' cm');
    if (v.eu != null) partes.push('número ' + fmt(v.eu));
    if (v.foot != null) partes.push('pie ' + fmt(v.foot) + ' cm');
    if (v.casco_talle) partes.push('uso casco ' + v.casco_talle);
    var para = s.quien === 'nino' ? ' Es para un chico.' : (s.quien === 'mujer' ? ' Es para mujer.' : '');
    return 'Hola, quiero confirmar mi talle de ' + PROD[s.prod].t.toLowerCase() + '.' + para + (partes.length ? ' Mis medidas: ' + partes.join(', ') + '.' : '') + ' La guía me recomienda ' + r.talle + '.';
  };

  function iniciar() {
    $$('.mpp[data-mpp]').forEach(function (root) {
      if (root.getAttribute('data-ok')) return;
      if (!(window.MPGuiaTalles && window.MPGuiaTalles._t)) return;
      root.setAttribute('data-ok', '1');
      root.mppPaso = new Paso(root);
    });
  }
  window.MPTallesPaso = { iniciar: iniciar, _calc: calcular };
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
})();
